module.exports = "/_next/static/images/16c9e4a02e7b77c9c329fcb4a98053bf-debit-phone.png";